import { makeStyles } from '@material-ui/core/styles';
import colors from '../../theme/colors';

export default makeStyles((theme) => ({
  container: {
    paddingTop   : theme.spacing(2),
    paddingBottom: theme.spacing(2),
    '& .MuiFormControl-root': {
      margin: theme.spacing(0.5),
      width: '90%'
    }
  },
  paper: {
    marginTop   : theme.spacing(5),
    padding     : theme.spacing(3),
    paddingRight: theme.spacing(0),
    paddingLeft : theme.spacing(0),
  },
  locationContainer: {
    maxHeight: theme.spacing(34.5),
    minHeight: theme.spacing(34.5),
    overflowY: 'scroll',
    '& .MuiGrid-container:hover': {
      backgroundColor: colors.PRIMARY_LIGHT
    },
    '& .MuiAccordionDetails-root': {
      padding: theme.spacing(0),
      flexDirection: 'column'
    },
    '& .MuiAccordionSummary-root': {
      padding: theme.spacing(0),
    },
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(0),
    }
  },
}));